import React, { createContext } from 'react'
import { IDayMapContext } from '../types'

export const DayMapContext = createContext<IDayMapContext | null>(null)

function DayMapProvider({ children, dayMap = {}, renderDayFn = () => null }: IDayMapContext) {
  const context = {
    dayMap,
    renderDayFn,
  }

  return <DayMapContext.Provider value={context}>{children}</DayMapContext.Provider>
}

export default DayMapProvider
